"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var _styled_1 = require("../../styled-components");
var omit_1 = __importDefault(require("lodash/omit"));
var Button = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Icon = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  i {\n    font-size: ", ";\n  }\n"], ["\n  i {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var _b;
    var defaultCss = _a.defaultCss;
    return (_b = defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.fontSize) !== null && _b !== void 0 ? _b : '';
});
var Text = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var TelephoneButton = function (_a) {
    var _b, _c;
    var className = _a.className, text = _a.text, hrefText = _a.hrefText, iconConfig = _a.iconConfig, textConfig = _a.textConfig, nativeProps = _a.nativeProps, buttonProps = __rest(_a, ["className", "text", "hrefText", "iconConfig", "textConfig", "nativeProps"]);
    var _d = react_1.useState(''), tel = _d[0], setTel = _d[1];
    react_1.useEffect(function () {
        if (hrefText && hrefText.length > 0)
            setTel(hrefText);
        // eslint-disable-next-line no-useless-escape
        else
            setTel(text.replace(/[^\d\+]/g, ''));
    }, [text]);
    var propsToPass = function (config, omitMyItems) {
        if (config) {
            var defaultOmitted = ['className', 'nativeProps'];
            var propsToOmit = omitMyItems
                ? defaultOmitted.concat(omitMyItems)
                : defaultOmitted;
            return __assign(__assign({}, config === null || config === void 0 ? void 0 : config.nativeProps), omit_1.default(config, propsToOmit));
        }
    };
    return (react_1.default.createElement("a", { className: "mb-0", href: "tel:" + tel },
        react_1.default.createElement(Button, __assign({ as: "button", className: "button " + (className !== null && className !== void 0 ? className : '') }, propsToPass(buttonProps)),
            react_1.default.createElement(Icon, __assign({ as: "span", className: "icon mb-0 " + ((_b = iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.className) !== null && _b !== void 0 ? _b : '') }, propsToPass(iconConfig)),
                react_1.default.createElement("i", { className: "material-icons" }, "phone")),
            react_1.default.createElement(Text, __assign({ as: "span", className: "mb-0 " + ((_c = textConfig === null || textConfig === void 0 ? void 0 : textConfig.className) !== null && _c !== void 0 ? _c : '') }, propsToPass(textConfig)), text))));
};
exports.default = TelephoneButton;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TelephoneButton.js.map